export const facilityContactConstants = {
    FACILITY_CONTACT_PENDING  : 'FACILITY_CONTACT_PENDING',
    FACILITY_CONTACT_FULFILLED: 'FACILITY_CONTACT_FULFILLED',
    FACILITY_CONTACT_REJECTED : 'FACILITY_CONTACT_REJECTED',

    UPDATE_FACILITY_CONTACT_PENDING  : 'UPDATE_FACILITY_CONTACT_PENDING',
    UPDATE_FACILITY_CONTACT_FULFILLED: 'UPDATE_FACILITY_CONTACT_FULFILLED',
    UPDATE_FACILITY_CONTACT_REJECTED : 'UPDATE_FACILITY_CONTACT_REJECTED',
};
